module.exports = __webpack_public_path__ + "img/no-data.cef13c1c.png";